var fvChannel = require('glRadio').channel('FV'),
    Backbone = require('backbone'),
    _ = require('underscore'),
    Document = require('./document.js'),
    Moment = require('moment'),
    $ = require('jquery');

module.exports = Backbone.Collection.extend({
    model: Document,
    url: function() {
        return fvChannel.request('apiUrl').docInfo;
    },
    fetch: function(options) {

        // TODO: this should be moved to init

        this.docReq = options.docReq; // (slices and vOptions)

        this.docSlices = _.map( this.docReq, function(d) {
            return _.omit(d, 'vOptions');
        });

        this.vOptions = _.map( this.docReq, function(d) {
            return d.vOptions;
        });

        return Backbone.Collection.prototype.fetch.call( this, _.extend( {}, options, {
            type: 'POST',
            data: JSON.stringify( this.docSlices )
        }));

    },

    /**
     * Hacked in here from current viewer reset workflow to
     * reflect that page rotation values may diverge from the database on load if the user lacks
     * rotate-save permission.
     * Notes that pages may have changed depending on the type of reset.
     * Loop through the prior documents and update any new ones,
     * rather than vice-versa; in case we can add/remove from the document collection
     */
    updatePageRotationsPostViewerReset: function( priorDocumentCollection ) {

        priorDocumentCollection.each( function( priorDocument ) {

            var document = this.findWhere({ docId: priorDocument.get('docId') });

            if (document) {

                var priorPageCollection = priorDocument.pageCollection;

                document.pageCollection.each( function(page) {

                    var pageId = page.get('pageId'),
                        correspondingPage = priorPageCollection.findWhere({ pageId: pageId });

                    if ( correspondingPage ) {

                        var correspondingPageRotation = correspondingPage.get('rotation');

                        page.setRotation( correspondingPageRotation ); // Don't need to check if same / not -- can overwrite

                        // also do the thumbnail -- it must exist
                        document.thumbCollection
                            .findWhere({ pageId: pageId  })
                            .setRotation( correspondingPageRotation );
                    }

                });

            }

        }, this);

    },

    /*
     * CRE Request for the 'PDF Combo' Functionality.
     * All docs with renderable pages requested (see 'allowPDFCombo' comment); not necessarily just the Active Document.
     * Requested in the order provided (not the active document first).
     */
    pdfRenderRequest: function() {

        var docsWithRenderablePgs = this.getDocumentsWithRenderablePgs();

        /*
         * Extra validation check (should already be blocked in the UI).
         * Note: this will stiff barf on URL page types ... (STILL?)
         */
        if (docsWithRenderablePgs.length < 1)
            return;

        return {
            renderRequest: {

                slices: _.map( docsWithRenderablePgs, function(d) {
                    return d.getDocSliceForRenderRequest();
                }),
                renderingParameters: {
                    containerType: 'pdf',
                    pageType: 'pdf'
                },
                destinations: {
                    allowDownload: true
                }
            }

        };

    },
    pdfFileName: function() {
        return 'FDD-Multi-Doc-PDF-' + Moment().format() + '.pdf';
        //fvChannel.request('settings').DATE_FMT_STR -- don't want '/" in file name --> will result in error ( TODO ... friendlier name )
    },

    getDocumentsWithRenderablePgs: function() {

        return this.filter( function( doc ) {
            return doc.hasRenderablePgs();
        });
    },
     /*
     *  Allow the operation if there's more than one document and at least 1 document has renderable pages.
     *  When invoked only documents that have renderable pages are requested -- this prevents the CRE from bombing on
     *  requests with documents that have multi-part-GOS-pages (at least as a stop gap until the CRE
     *  recognizes that page type as unrenderable and ignores them as it does with other unrenderable page types).
     *  TODOs / notes --
     *  - May want to combo this concept with PDF renderable pages -- unsure if URL page types are supposed to be rendered by the CRE ...
     *  - Multi-part-GOS-pages -- I'm assuming requesting a PDF is not an issue for this page types b/c the document
     *    containing it is now assumed to have only have 1 page of this type.  In this case, an unrenderable view will be shown
     *    in PDF mode.
     *  - This 'renderable' logic should all should be be cleaned up / made consistent when get time and learn how CRE treats URL pages types
     *      -- eg do something similar when making PDF requests for a document to only include pages that are renderable
     * */
    allowPDFCombo: function() {
        return this.length > 1 && this.getDocumentsWithRenderablePgs().length > 0;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/documents.js
 ** module id = 391
 ** module chunks = 0
 **/